// В качестве примера брался файл:
// wgnp/personal/backup_code_reset/jinja2/backup_code_reset/_step_email.js

import AjaxRequest from '@wgn/ajaxrequest';
import Riddler from 'wg-riddler/dist/riddler';
import { mapState } from 'vuex';

import CountrySelect from '../../../../../static-source/components/country_select';
import BMessageError from '../../../../../static-source/components/b_message_error/b_message_error';
import InputError from '../../../../../static-source/components/input_error/input_error';
import Spinner from '../../../../../static-source/components/spinner/spinner';

import clearInputErrorsMixinConstructor from '../../../../../static-source/mixins/clearInputErrors';
import getErrorTypeMixin from '../../../../../static-source/mixins/getErrorType';
import prepareErrors from '../../../../../static-source/helpers/prepareErrors';
import { CELLPHONE_RECOVERY_STORE_NAMESPACE } from '../store';

const reasonsToResubmitPow = ['pow:invalid', 'pow:required'];
const reasonsToUpdateCaptcha = ['captcha:invalid', 'captcha:required', '__all__:not_found'];
const RIDDLER_NEW_CHALLENGE_REQUEST_TIMEOUT = 1000;

const clearInputErrorsMixin = clearInputErrorsMixinConstructor({
    cellphone: 'phone',
});

export default {
    name: 'cellphone-recovery-step-phone',
    template: '#js-tmpl-cellphone-recovery-step-phone',
    mixins: [getErrorTypeMixin, clearInputErrorsMixin],

    components: {
        BMessageError,
        CountrySelect,
        InputError,
        Spinner,
    },

    props: {
        passwordResetIndexUrl: String,
    },

    data() {
        return {
            selectedCountry: null,
            cellphone: this.storedCellphone ?? '',
            templatePrefix: 'cellphone-recovery-error-step-phone',
            ERRORS_TYPES: {
                captcha: ['captcha:invalid', 'captcha:required'],
                phone: ['cellphone:invalid', 'cellphone:required', 'cellphone:max_length', 'cellphone:min_length'],
                main: ['__all__:passwordless_account'],
            },
            riddler: null,
            processing: false,
            error: false,
            errors: [],
            processingNewChallenge: false,
            challengeType: null,
            challengeKey: null,
            challengeResult: null,
            captchaInput: '',
        };
    },

    computed: {
        ...mapState(CELLPHONE_RECOVERY_STORE_NAMESPACE, {
            countrySelectOptions: state => state.CountrySelectOptions || [],
            codeLifetime: state => state.codeLifetime || '',
            riddlerFeature: state => state.riddlerFeature || '',
            riddlerDefaultType: state => state.riddlerDefaultType || '',
        }),
        ...mapState('settings', {
            staticUrl: state => state.staticUrl,
        }),
        cellphoneRecoverySettings() {
            return this.$store.state[CELLPHONE_RECOVERY_STORE_NAMESPACE] || {};
        },
        defaultChallengeType() {
            return this.cellphoneRecoverySettings.riddlerDefaultType;
        },
        linkToResetPasswordPage() {
            return this.$store.state.cellphone_recovery.urls.passwordResetIndexUrl;
        },
        countryCodeByIp() {
            return this.$store.state.cellphone_recovery.countryCodeByIp;
        },
    },

    watch: {
        captchaInput(val) {
            if (this.error && val !== '') {
                this.errors = this.errors.filter(
                    error => !this.ERRORS_TYPES.captcha.includes(error)
                );

                if (this.errors.length === 0) {
                    this.error = false;
                }
            }
        },
        selectedCountry: {
            handler(newVal) {
                if (newVal && newVal.value) {
                    this.$nextTick(() => {
                        const hiddenInput = this.$el.querySelector('[name="country_code"]');
                        if (hiddenInput) {
                            hiddenInput.value = newVal.value;
                        }
                    });
                }
            },
            deep: true,
        },
        countrySelectOptions: {
            handler(newVal) {
                if (newVal && newVal.length > 0 && !this.selectedCountry) {
                    const [firstCountry] = newVal;
                    if (firstCountry && firstCountry.value) {
                        this.selectedCountry = firstCountry;
                    }
                }
            },
            immediate: true,
        },
    },

    methods: {
        setPreferredCountry() {
            const suggestCountry = this.countrySelectOptions.find(
                ({ value }) => value === this.countryCodeByIp
            );

            this.selectedCountry = suggestCountry;
        },
        getCookie(name) {
            let cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';');
                for (let i = 0; i < cookies.length; i += 1) {
                    const cookie = cookies[i].trim();
                    if (cookie.substring(0, name.length + 1) === `${name}=`) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        },

        submitPhone(event) {
            if (this.processing) {
                return;
            }
            if (this.processingNewChallenge) {
                this.processing = true;
                return;
            }

            if (this.cellphone.length === 0) {
                this.error = true;
                this.errors = ['cellphone:required'];
                this.$refs.input_phone.focus();
                return;
            }
            if (this.cellphone.length < this.$store.state.cellphone_recovery.MinLength) {
                this.error = true;
                this.errors = ['cellphone:min_length'];
                this.$refs.input_phone.focus();
                return;
            }
            if (this.cellphone.length > this.$store.state.cellphone_recovery.MaxLength) {
                this.error = true;
                this.errors = ['cellphone:max_length'];
                this.$refs.input_phone.focus();
                return;
            }
            if (this.cellphone && !/^\d+$/.test(this.cellphone)) {
                this.error = true;
                this.errors = ['cellphone:invalid'];
                this.$refs.input_phone.focus();
                return;
            }

            if (
                this.challengeType === Riddler.ChallengeType.CAPTCHA
                && this.captchaInput.length === 0
            ) {
                this.error = true;
                this.errors = ['captcha:required'];
                this.$refs.input_captcha.focus();
                return;
            }

            const form = event.target;
            const data = new FormData(form);

            let url = form.getAttribute('action');

            if (this.challengeType === Riddler.ChallengeType.CAPTCHA) {
                url += '?type=captcha';
            }

            const headers = {
                'X-WG-Challenge-Key': this.challengeKey
            };

            AjaxRequest.submit(data, {
                url,
                headers,
                contentType: false,
                processData: false,
                onRequestStart: () => {
                    this.processing = true;
                },
                onRequestEnd: () => {
                    this.processing = false;
                    this.error = false;
                    this.errors = [];
                },
                success: this.submitSuccess,
                error: this.submitError
            });
        },
        submitSuccess(response) {
            this.$emit('update', {
                ...response.settings,
                phoneConfirmed: true,
                cellphone: this.selectedCountry.cellphone_code + this.cellphone
            });

            this.riddler.clear();
        },
        submitError(xhr) {
            this.errors = prepareErrors(xhr);
            // eslint-disable-next-line max-len
            const relaunchPowChallenge = reasonsToResubmitPow.some(error => this.errors.includes(error));

            if (relaunchPowChallenge) {
                this.processing = true;
            } else {
                this.error = true;
            }

            const updateCaptcha = reasonsToUpdateCaptcha.some(error => this.errors.includes(error));

            if (updateCaptcha) {
                this.updateCaptchaChallenge();
            } else {
                this.updateChallenge();
            }

            if (this.errors.some(err => this.ERRORS_TYPES.phone.includes(err))) {
                this.$refs.input_phone.focus();
            } else if (this.errors.some(err => this.ERRORS_TYPES.captcha.includes(err))) {
                this.captchaInput = '';
                this.$refs.input_captcha.focus();
            } else if (this.errors.includes('__all__:passwordless_account')) {
                window.location.href = `${this.linkToResetPasswordPage}?mode=set`;
            } else if (this.errors.includes('__all__:already_authenticated')) {
                window.location.href = window.Settings.Authentication.LoginUrl;
            }
        },

        initChallenge() {
            const url = this.$refs.riddlerChallenge.getAttribute('action');
            const feature = this.cellphoneRecoverySettings.riddlerFeature;
            const staticUrl = (window && window.Settings && window.Settings.STATIC_URL);

            this.riddler = new Riddler({
                feature,
                url,
                preferredChallengeType: this.defaultChallengeType,
                powEvalPath: `${staticUrl}wgni/js/riddler/eval.js`,
                powSHA3Path: `${staticUrl}wgni/js/riddler/sha3.js`,
                challengeKeyHeader: 'HTTP_X_WG_CHALLENGE_KEY',
                syncStorageEnabled: true,
                error: () => {
                    this.updateCaptchaChallenge();
                },
                resolved: this.challengeResolved,
            });

            this.processingNewChallenge = true;
            this.riddler.solve();
        },

        challengeResolved(result) {
            if (!result.results) {
                this.updateChallenge(Riddler.ChallengeType.CAPTCHA);
                return;
            }

            this.processingNewChallenge = false;
            this.challengeType = result.type;
            this.challengeKey = result.key;
            this.challengeResult = result.results[this.challengeType];

            if (this.processing) {
                this.$nextTick(() => {
                    if (this.cellphone.length === 0) {
                        this.error = true;
                        this.errors = ['cellphone:required'];
                        this.$refs.input_phone.focus();
                    } else {
                        this.$refs.input_captcha.focus();
                    }
                });
            }

            this.processing = false;
        },
        updateChallenge(challengeType = this.defaultChallengeType) {
            this.processingNewChallenge = true;
            setTimeout(() => {
                this.riddler.update(challengeType);
            }, RIDDLER_NEW_CHALLENGE_REQUEST_TIMEOUT);
        },
        updateCaptchaChallenge(resetErrors = false) {
            if (this.processingNewChallenge) {
                return;
            }

            if (
                resetErrors
                || this.challengeType === 'pow'
                || this.errors.includes('__all__:not_found')
            ) {
                this.error = false;
                if (this.errors.includes('__all__:not_found')) {
                    this.captchaInput = '';
                }
            }

            this.updateChallenge(Riddler.ChallengeType.CAPTCHA);
        },
    },

    mounted() {
        this.initChallenge();
        if (this.$refs.input_phone) {
            this.$refs.input_phone.focus();
        }
    },
};
